import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Form, Spin, Input, Button, Row, Col } from 'antd';

import UserStore from '../../../stores/UserStore';
import { GAEvent } from '../../../utils/tracking';

interface Props {
    first_name?: string;
    last_name?: string;
    email?: string;
    company?: string;
    handleLogin?: () => void;
    onLoginSuccess?: () => void;
}

interface LoginSubmitProps {
    email: string;
    password1: string;
}

interface IHandleSubmit {
    preventDefault: () => void;
}

const SignIn: React.FC<Props> = observer(props => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState<string | null>(null);

    const submitLogin = (values: LoginSubmitProps) => {
        setLoading(true);

        GAEvent('Form', 'Sign In');

        UserStore.login(values.email, values.password1, props?.onLoginSuccess).then(() => {
            if (props?.handleLogin) {
                props.handleLogin();
            }
        });

        setLoading(false);
    };

    return (
        <>
            <Form onFinish={submitLogin} layout={'vertical'}>
                <Row className="mb-0">
                    <Col span={24}>
                        <Form.Item
                            name="email"
                            label={'Email'}
                            validateTrigger={'onBlur'}
                            rules={[
                                {
                                    type: 'email',
                                    required: true,
                                    message: 'Please enter a valid email address',
                                },
                            ]}
                            initialValue={props?.email || UserStore.guest_email}
                            hasFeedback={true}
                            className="mb-0"
                        >
                            <Input onChange={event => setEmail(event.target.value)} autoComplete={'username'} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="password1"
                            label={'Password'}
                            rules={[
                                {
                                    required: true,
                                    message: 'Password is required',
                                },
                                {
                                    min: 1,
                                    message: 'Password must have at least 8 characters',
                                },
                            ]}
                            hasFeedback
                        >
                            <Input.Password type={'password'} autoComplete={'current-password'} />
                        </Form.Item>
                    </Col>

                    <Button type="primary" loading={loading} htmlType="submit" block>
                        Login
                    </Button>
                </Row>
            </Form>
        </>
    );
});

export default SignIn;
